import { render, staticRenderFns } from "./LegalResult.vue?vue&type=template&id=77d5136e&scoped=true&"
import script from "./LegalResult.vue?vue&type=script&lang=js&"
export * from "./LegalResult.vue?vue&type=script&lang=js&"
import style0 from "./LegalResult.vue?vue&type=style&index=0&id=77d5136e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d5136e",
  null
  
)

export default component.exports